export default "__VITE_ASSET__Dl18r2lj__"